import {call, put, select, takeEvery} from "redux-saga/effects";
import { push } from "react-router-redux";
import {
    onModifierArchive,
    onModifierArchiveFail,
    onModifierArchiveSuccess,
    onModifierCategoriesNew,
    onModifierCategoriesNewFail,
    onModifierCategoriesNewSuccess,
    onModifierCategoryNameEdit,
    onModifierCategoryNameEditFail,
    onModifierCategoryNameEditSuccess,
    onModifierEdit,
    onModifierEditFail,
    onModifierEditSuccess,
    onModifierLoad,
    onModifierLoadFail,
    onModifierLoadSuccess,
    onModifierNew,
    onModifierNewFail,
    onModifierNewSuccess,
    onModifierRemove,
    onModifierRemoveFail,
    onModifierRemoveSuccess,
    onModifiersChangeItemPosition,
    onModifiersChangeItemPositionFail,
    onModifiersChangeItemPositionSuccess,
    onModifiersChangePosition,
    onModifiersChangePositionFail,
    onModifiersChangePositionSuccess,
    onModifiersEdit,
    onModifiersEditFail,
    onModifiersEditSuccess,
    onModifiersLoad,
    onModifiersLoadFail,
    onModifiersLoadSuccess,
    onModifiersModalEdit,
    onModifiersNew,
    onModifiersNewFail,
    onModifiersNewSuccess,
    onModifierUnarchive,
    onModifierUnarchiveFail,
    onModifierUnarchiveSuccess
} from "./actions";
import {
    addModifierCategory,
    addModifierNewCategory,
    archiveModifier,
    changeModifierItemPosition, changeModifierPosition,
    editModifierCategory,
    editModifierCategoryName,
    editModifierItem,
    loadModifiers,
    modifierLoad,
    modifierNew,
    modifierRemove,
    unarchiveModifier
} from "./api";

function* fetchInitData() {
    try {
        const modifiers = yield select(state => state.modifiers);

        const filter = {
            status: modifiers.status,
        }
        const response = yield call(loadModifiers, filter)
        yield put(onModifiersLoadSuccess(response))
    }
    catch (e) {
        yield put(onModifiersLoadFail())
    }
}

function* fetchModifierData(action) {
    try {
        const response = yield call(modifierLoad, action.itemId);
        yield put(onModifierLoadSuccess(response));
    } catch (e) {
        yield put(onModifierLoadFail(e));
    }
}

function* onChangePosition(action) {
    try {
        const response = yield call(changeModifierPosition, action.items)
        yield put(onModifiersChangePositionSuccess(response))
    }
    catch (e) {
        yield put(onModifiersChangePositionFail())
    }
}
function* onChangeItemPosition(action) {
    try {
        const response = yield call(changeModifierItemPosition, action.items)
        yield put(onModifiersChangeItemPositionSuccess(response))
    }
    catch (e) {
        yield put(onModifiersChangeItemPositionFail())
    }
}

function* newCategory(action) {
    try {
        const response = yield call(addModifierNewCategory, action.data)
        yield put(onModifiersNewSuccess(response))
        yield put(push(`/chain/menu/${action.slug}/modifiers`));
    }
    catch (e) {
        yield put(onModifiersNewFail(e.message))
        yield put(onModifierLoadFail(e));
        alert(e.message)
    }
}

function* newModifierCategory(action) {
    try {
        const response = yield call(addModifierCategory, action.name)
        yield put(onModifierCategoriesNewSuccess(response))
        yield put(onModifiersLoad())
    }
    catch (e) {
        yield put(onModifierCategoriesNewFail())
    }
}

function* editCategory(action) {
    try {
        const response = yield call(editModifierCategory, action.data)
        yield put(onModifiersEditSuccess(response))
        yield put(push(`/chain/menu/${action.slug}/modifiers`));
    }
    catch (e) {
        yield put(onModifiersEditFail(e))
        alert(e.message)
    }
}

function* editCategoryName(action) {
    try {
        const response = yield call(editModifierCategoryName, action.data)
        yield put(onModifierCategoryNameEditSuccess(response))
        yield put(onModifiersLoad())
        yield put(onModifiersModalEdit(false))
    }
    catch (e) {
        yield put(onModifierCategoryNameEditFail(e))
        alert(e.message)
    }
}

function* editModifier(action) {
    try {
        const response = yield call(editModifierItem, action.id, action.data)
        yield put(onModifierEditSuccess(response))
        yield put(onModifierLoad(action.id))
    }
    catch (e) {
        yield put(onModifierEditFail(e))
        alert(e.message)
    }
}

function* newModifier(action) {
    try {
        const response = yield call(modifierNew, action.id, action.data);
        yield put(onModifierNewSuccess(response));
        yield put(onModifierLoad(action.id))
    } catch (e) {
        yield put(onModifierNewFail(e));
        alert(e.message)
    }
}

function* removeModifier(action) {
    try {
        const response = yield call(modifierRemove, action.cat_id, action.id);
        yield put(onModifierRemoveSuccess(response));
        yield put(onModifierLoad(action.cat_id))
    } catch (e) {
        yield put(onModifierRemoveFail(e));
        alert(e.message)
    }
}

function* modifierArchive(action) {
    try {
        const response = yield call(archiveModifier, action.id)
        yield put(onModifierArchiveSuccess(response))
        yield put(onModifierLoad(action.id))
    }
    catch (e) {
        yield put(onModifierArchiveFail(e))
    }
}

function* modifierUnarchive(action) {
    try {
        const response = yield call(unarchiveModifier, action.id)
        yield put(onModifierUnarchiveSuccess(response))
        yield put(onModifierLoad(action.id))
    }
    catch (e) {
        yield put(onModifierUnarchiveFail(e))
    }
}


function* categoriesSaga() {
    yield takeEvery(onModifiersLoad().type, fetchInitData);
    yield takeEvery(onModifierLoad().type, fetchModifierData);
    yield takeEvery(onModifiersChangePosition().type, onChangePosition);
    yield takeEvery(onModifiersChangeItemPosition().type, onChangeItemPosition);
    yield takeEvery(onModifiersNew().type, newCategory);
    yield takeEvery(onModifierNew().type, newModifier);
    yield takeEvery(onModifiersEdit().type, editCategory);
    yield takeEvery(onModifierCategoryNameEdit().type, editCategoryName);
    yield takeEvery(onModifierEdit().type, editModifier);
    yield takeEvery(onModifierRemove().type, removeModifier);
    yield takeEvery(onModifierCategoriesNew().type, newModifierCategory);
    yield takeEvery(onModifierArchive().type, modifierArchive);
    yield takeEvery(onModifierUnarchive().type, modifierUnarchive);
}

export default categoriesSaga;
